var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CompassTooltip",
    {
      attrs: {
        content: _vm.getTooltipContent,
        placement: "bottom-start",
        arrow: false,
        disabled: !_vm.getTooltipContent
      }
    },
    [
      _c(
        "div",
        { staticClass: "automation-pieces" },
        [
          _vm._l(_vm.visiblePieces, function(piece, index) {
            return _c(
              "div",
              { key: index, staticClass: "automation-pieces__bubble" },
              [
                piece.logoUrl
                  ? _c("img", {
                      attrs: { src: piece.logoUrl, alt: piece.displayName }
                    })
                  : _vm._e()
              ]
            )
          }),
          _vm._v(" "),
          _vm.remainingCount
            ? _c(
                "div",
                {
                  staticClass:
                    "typographies-heading-h4 automation-pieces__bubble"
                },
                [
                  _vm._v(
                    "\n            +" +
                      _vm._s(_vm.remainingCount) +
                      "\n        "
                  )
                ]
              )
            : _vm._e()
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }